import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "../utils/fb";
import { ToastContainer, toast } from "react-toastify";

const Segment = styled.div`
  border: 1px solid #e7e9ed;
  margin: auto;
  width: 30%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error: ""
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ isLoading: true });
    const { history } = this.props;

    signInWithEmailAndPassword(this.email.value, this.password.value)
      .then(res => {
        this.setState({ isLoading: false });
        //const locState = location.state
        history.replace("/vacancies");
      })
      .catch(e => {
        toast.warn("Unable to login. Make sure your details are correct");
        this.setState({ error: e, isLoading: false });
      });
  }

  render() {
    const { isLoading } = this.state;
    return (
      <div className="mt4 pt3 mb5">
        <ToastContainer position="top-center" />
        <Segment className="mt3 pa4 bg-white">
          <h1 className="f3 fw5 pb3 tc lh-copy">Login</h1>
          <form onSubmit={this.handleSubmit}>
            <div className="field-body mb3">
              <div className="field">
                <label className="b">Email</label>
                <input
                  required
                  className="input"
                  type="text"
                  placeholder=""
                  ref={x => (this.email = x)}
                />
              </div>
            </div>

            <div className="field-body mb2">
              <div className="field">
                <label className="b">Password</label>
                <input
                  required
                  className="input"
                  type="password"
                  placeholder=""
                  ref={x => (this.password = x)}
                />
              </div>
            </div>
            <div>
              <Link to="/register" className="blue">
                Register?
              </Link>
            </div>
            <button
              type="submit"
              className={`button is-link ph5 mt4 ${isLoading && "is-loading"}`}
            >
              Submit
            </button>
          </form>
        </Segment>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/login.js